module.exports = __webpack_public_path__ + "static/media/favicon.e3f07e13.ico";